module.exports = __webpack_public_path__ + "img/color-drop_en.fbf2843.jpg";